module.exports = __webpack_public_path__ + "img/icon-waitlist.5cf439c3.svg";